import { useEffect, useState } from 'react';

// Returns the id of the section currently nearest the top of the viewport.
// Reads layout at most once per animation frame and only updates state when the section changes.
export function useActiveSection(ids: string[], offset = 160) {
  const key = ids.join('|');
  const [active, setActive] = useState(ids[0]);

  useEffect(() => {
    const list = key.split('|');
    let frame = 0;

    function measure() {
      frame = 0;
      let current = list[0];
      for (const id of list) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top - offset <= 0) current = id;
      }
      setActive((prev) => (prev === current ? prev : current));
    }

    function onScroll() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [key, offset]);

  return active;
}
